module.exports = {
  DATE_ALPHA_MONTH: 'MMM',
  DATE_ALPHA_MONTH_FULL: 'MMMM',
  DATE_ALPHA_WEEKDAY: 'ddd',
  DATE_ALPHA_WEEKDAY_FULL: 'dddd',
  DATE_ALPHA_POSTMONTH: 'MMM YYYY',
  DATE_ALPHA_SHORT: 'MMM DD, YYYY',
  DATE_ALPHA_LONG: 'MMMM DD, YYYY',
  DATE_ALPHA_MEDIUM: 'ddd, MMM DD, YYYY',
  DATE_NUMERIC_MONTH: 'MM',
  DATE_NUMERIC_DAY: 'DD',
  DATE_NUMERIC_YEAR: 'YYYY',
  DATE_NUMERIC_MONTH_DAY: 'MM/DD',
  DATE_NUMERIC_POSTMONTH: 'MM/YYYY',
  DATE_NUMERIC_STANDARD: 'MM/DD/YYYY',
  DATE_NUMERIC_ISO: 'YYYY-MM-DD',
  DATETIME_ISO: 'YYYY-MM-DDTHH:mm:ss',
  TIME_HOUR: 'hh',
  TIME_HOUR24: 'HH',
  TIME_MINUTE: 'mm',
  // everything below here should include 3 letter timezone
  // that needs to be provided, we can't derive that in browser
  TIME_SHORT: 'h:mm A',
  TIME_SHORT_PRECISE: 'h:mm:ss A',
  TIME_SHORT24: 'HH:mm',
  TIME_SHORT24_PRECISE: 'HH:mm:ss',
  DATETIME_ALPHA_SHORT: 'MMM DD, YYYY h:mm A',
  DATETIME_ALPHA_SHORT_PRECISE: 'MMM DD, YYYY h:mm:ss A',
  DATETIME_ALPHA_MEDIUM: 'ddd, MMM DD, YYYY h:mm A',
  DATETIME_NUMERIC_SHORT: 'MM/DD/YYYY h:mm A',
  DATETIME_NUMERIC_SHORT_PRECISE: 'MM/DD/YYYY h:mm:ss A',
  DATETIME_NUMERIC_ISO: 'YYYY-MM-DD HH:mm',
  DATETIME_NUMERIC_ISO_PRECISE: 'YYYY-MM-DD HH:mm:ss',
  DATE_NUMERIC_LONG: 'DD MMMM YYYY'
}
